import { render, staticRenderFns } from "./ColorListV3.vue?vue&type=template&id=09466c0c"
import script from "./ColorListV3.vue?vue&type=script&lang=js"
export * from "./ColorListV3.vue?vue&type=script&lang=js"
import style0 from "./ColorListV3.vue?vue&type=style&index=0&id=09466c0c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports